
export const writeObject = ( key, object ) => {
    window.localStorage.setItem( key, JSON.stringify( object ) )
}

export const readObject = key => JSON.parse( window.localStorage.getItem( key ) )

export const removeObject = key => window.localStorage.removeItem( key )
